'use client';

import React__default from 'react';

var CheckTagIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#003699' : _b;
    return (React__default.createElement("svg", { width: '12', height: '12', viewBox: '0 0 12 12', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("path", { d: 'M1.2939 0.666992C1.13335 0.666992 0.972782 0.728306 0.850271 0.850816C0.605248 1.09584 0.605248 1.49305 0.850271 1.73807L5.11257 6.00033L0.850271 10.2626C0.605249 10.5076 0.605248 10.9048 0.850271 11.1498C0.972939 11.2725 1.13327 11.3337 1.2939 11.3337C1.45453 11.3337 1.61487 11.2725 1.73754 11.1498L5.99984 6.88758L10.2621 11.1498C10.3848 11.2725 10.5451 11.3337 10.7058 11.3337C10.8664 11.3337 11.0267 11.2725 11.1494 11.1498C11.3944 10.9048 11.3944 10.5076 11.1494 10.2626L6.8871 6.00033L11.1494 1.73807C11.3944 1.49305 11.3944 1.09584 11.1494 0.850816C10.9044 0.605796 10.5072 0.605796 10.2621 0.850816L5.99984 5.11307L1.73754 0.850816C1.61502 0.728306 1.45445 0.666992 1.2939 0.666992Z', fill: color })));
};
var CheckTagIcon$1 = React__default.memo(CheckTagIcon);

export { CheckTagIcon$1 as default };
//# sourceMappingURL=index.js.map
